define('taoQtiItem/qtiItem/core/interactions/UploadInteraction',['taoQtiItem/qtiItem/core/interactions/BlockInteraction'], function(InlineInteraction){
    var UploadInteraction = InlineInteraction.extend({
        'qtiClass' : 'uploadInteraction'
    });
    return UploadInteraction;
});


